import { Component, DestroyRef, inject, OnInit } from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  ValidationErrors,
  Validators,
} from '@angular/forms';
import { DynamicDialogRef } from 'primeng/dynamicdialog';
import { DialogControlService } from '@shared/services/dialog-control.service';
import {
  CustomValidator,
  passwordValidator,
} from '@shared/services/custom-validatior.abstract';
import { SuceesChangepasswordComponent } from '@shared/components/sucees-changepassword/sucees-changepassword.component';
import { HttpErrorResponse } from '@angular/common/http';
import { ToastService } from '@shared/services/toast.service';
import { ProfileService } from '@core/services/profile.service';
import { autoUnsubWith } from '@shared/services/utility.abstract';

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
styleUrls: [
  '../../auth/login/login.component.scss',
  './change-password.component.scss'
]
})
export class ChangePasswordComponent implements OnInit {
  readonly destroyRef = inject(DestroyRef);
  resetPasswordForm: FormGroup;
  errorMessage: boolean = false;
  constructor(
    private readonly fb: FormBuilder,
    public readonly ref: DynamicDialogRef,
    private readonly service: ProfileService,
    private readonly dialogControlService: DialogControlService,
    private readonly toastService: ToastService
  ) {}

  ngOnInit() {
    this.resetPasswordForm = this.fb.group(
      {
        oldPassword: [
          '',
          [
            Validators.required,
            Validators.minLength(3),
            Validators.maxLength(15),
          ],
        ],
        newPassword: [
          '',
          [
            Validators.required,
            Validators.minLength(8),
            Validators.maxLength(15),
            passwordValidator,
          ],
        ],
        confirmPassword: [
          '',
          [
            Validators.required,
            Validators.minLength(8),
            Validators.maxLength(15),
            passwordValidator,
          ],
        ],
      },
      { validators: this.passwordMatchValidator }
    );
  }

  resetPassword(data): void {
    if (this.resetPasswordForm.valid) {
      if (data.newPassword === data.confirmPassword) {
        const requestParams = {
          oldPassword: this.resetPasswordForm.get('oldPassword').value,
          newPassword: this.resetPasswordForm.get('newPassword').value,
        };
        this.service
          .resetUserPassword(requestParams)
          .pipe(autoUnsubWith(this.destroyRef))
          .subscribe({
            next: (_res: any) => {
              this.dialogControlService.openDialog(
                SuceesChangepasswordComponent,
                {
                  width: '30%',
                  data: {
                    IsForcePasswordUpdate: true,
                  },
                }
              );
            },
            error: (error: HttpErrorResponse) => {
              this.toastService.showToastMessage(
                'error',
                'Error',
                error.error.message
              );
            },
          });
      } else {
        this.errorMessage = true;
      }
    } else {
      CustomValidator.markFormGroupTouched(this.resetPasswordForm);
    }
  }

  closeDialog() {
    this.ref.close();
  }

  onPasswordKeyDown(event: KeyboardEvent, controlName: string): void {
    const maxLength = 15;
    const control = this.resetPasswordForm.get(controlName);
    const currentValueLength = control?.value.length ?? 0;

    if (
      currentValueLength >= maxLength &&
      event.key !== 'Backspace' &&
      event.key !== 'Delete'
    ) {
      event.preventDefault();
    }
  }

  passwordMatchValidator(form: FormGroup): ValidationErrors | null {
    const newPassword = form.get('newPassword');
    const confirmPassword = form.get('confirmPassword');
    if (!newPassword || !confirmPassword) return null;
    return confirmPassword.value &&
      newPassword.value &&
      newPassword.value !== confirmPassword.value
      ? { passwordMismatch: true }
      : null;
  }
}
